'use client';

import React, { useState, useEffect } from 'react';
import { MapPinIcon, ClockIcon } from '@heroicons/react/24/outline';

export default function EventBanner() {
  const [timeStr, setTimeStr] = useState('');

  useEffect(() => {
    const update = () => {
      const now = new Date();
      const hours = now?.getHours()?.toString()?.padStart(2, '0');
      const mins = now?.getMinutes()?.toString()?.padStart(2, '0');
      setTimeStr(`${hours}:${mins}`);
    };
    update();
    const interval = setInterval(update, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-accent text-accent-foreground px-4 py-2 flex items-center justify-between text-xs font-semibold">
      <div className="flex items-center gap-1.5">
        <MapPinIcon className="w-3 h-3" />
        <span>New Milton RFC, Normans Way</span>
      </div>
      <div className="flex items-center gap-1.5">
        <ClockIcon className="w-3 h-3" />
        <span>11:00 AM – 4:30 PM</span>
        {timeStr && (
          <span className="opacity-70 font-normal ml-1">Now: {timeStr}</span>
        )}
      </div>
    </div>
  );
}